var _style, _switch;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAccessGray({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 32 32",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:none;stroke:#414143;}\n\t.st2{fill:none;stroke:#414143;stroke-linecap:round;stroke-linejoin:round;}\n")), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    width: 1,
    height: 1,
    requiredExtensions: "http://ns.adobe.com/AdobeIllustrator/10.0/"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,0h32v32H0V0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 10,
    cy: 10.8,
    rx: 4,
    ry: 3.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M18,23c0-3.6-3.6-6.5-8-6.5S2,19.4,2,23"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 21,
    cy: 10.2,
    rx: 3.5,
    ry: 3.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m28 21c0-3-3.1-5.5-7-5.5-2.4 0-4.5 1-5.8 2.4"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAccessGray);
export default __webpack_public_path__ + "static/media/ic_access_gray.d86d2fa91805c8fc128711725abfd720.svg";
export { ForwardRef as ReactComponent };